<script setup lang="ts">
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useWizardStore } from '@/stores/wizard'
import WizardProgress from '@/components/wizard/WizardProgress.vue'
import WizardStep1 from '@/components/wizard/WizardStep1.vue'
import WizardStep2 from '@/components/wizard/WizardStep2.vue'
import WizardStep3 from '@/components/wizard/WizardStep3.vue'
import WizardStep4 from '@/components/wizard/WizardStep4.vue'
import WizardReview from '@/components/wizard/WizardReview.vue'

const router = useRouter()
const wizard = useWizardStore()

onMounted(() => {
  if (!wizard.initialized) {
    router.replace({ name: 'incident-list' })
  }
})

function handleStepClick(step: number) {
  wizard.currentStep = step
}
</script>

<template>
  <div class="h-full flex flex-col">
    <!-- Header -->
    <header class="bg-primary-container px-4 py-4 flex items-center gap-4">
      <button
        type="button"
        class="flex items-center gap-1.5 text-white/60 hover:text-white transition-colors text-sm font-mono"
        @click="router.push({ name: 'incident-list' })"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
        Incidents
      </button>
      <span class="text-white text-base font-semibold tracking-wide flex-1 text-center pr-12">
        New Incident
      </span>
    </header>

    <!-- Progress -->
    <div class="bg-surface border-b border-border">
      <div class="max-w-2xl mx-auto">
        <WizardProgress
          :current-step="wizard.currentStep"
          @step-click="handleStepClick"
        />
      </div>
    </div>

    <!-- Step content -->
    <div class="flex-1 overflow-y-auto">
      <div class="max-w-2xl mx-auto px-4 py-8">
        <div class="bg-surface border border-border p-6 sm:p-8">
          <WizardStep1 v-if="wizard.currentStep === 1" />
          <WizardStep2 v-else-if="wizard.currentStep === 2" />
          <WizardStep3 v-else-if="wizard.currentStep === 3" />
          <WizardStep4 v-else-if="wizard.currentStep === 4" />
          <WizardReview v-else-if="wizard.currentStep === 'review'" />
        </div>
      </div>
    </div>
  </div>
</template>
